import Vue from 'vue'
import router from './router/'
import store from './store/'
import './registerServiceWorker'
import './plugins/vuetify'
import './plugins/numeric'
import './plugins/validate'
import './plugins/acl/index'
import './plugins/config'
import './plugins/socket'
import ToastPlugin from './plugins/toast'
Vue.use(ToastPlugin)
import 'roboto-fontface/css/roboto/roboto-fontface.css'
import 'font-awesome/css/font-awesome.css'
import './assets/theme/default.styl'
import './assets/theme/overwrite.css'
import './assets/theme/reports.css'
import * as VueGoogleMaps from 'vue2-google-maps'

Vue.use(VueGoogleMaps, {
  load: {
    key: 'AIzaSyDXHt8CU-4u3gYsonUq8rKefJz6oPAyXGA',
    libraries: 'places,geometry',
    language: 'es',
  },
  installComponents: true,
})

import App from './App.vue'

Vue.config.productionTip = false

const app = new Vue({
  router,
  store,
  render: h => h(App),
})

app.$mount('#app')
